import Link from '../../views/Onboard';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    createCompany: (
      companyName,
      companyAlias,
      contactFirstName,
      contactLastName,
      contactEmail,
      contactPhoneNumber,
      adminFirstName,
      adminLastName,
      adminEmail,
      adminPhoneNumber,
      fun
    )=>{
      dispatch(actions.customerregister(
        companyName,
        companyAlias,
        contactFirstName,
        contactLastName,
        contactEmail,
        contactPhoneNumber,
        adminFirstName,
        adminLastName,
        adminEmail,
        adminPhoneNumber
      )).then(res => {
        console.log("++++");
        console.log(res);
        fun();
      }).catch(error => {
        console.log("it has an error!!!!");
        // dispatch(push(`/${locale}/`))
      });
    },

    gotoLogin: ()=>{
      dispatch(push(`/${locale}/`));
    },

    resetPopError: ()=>{
      dispatch(actions.resetPopError());
    },

    resolveToken: token=>{
      dispatch(actions.resolveToken(token)).catch(error => {
        dispatch(push(`/${locale}/`))
      })
    },

    customerexist: (email,fun)=>{
      dispatch(actions.customerexist(email)).then(()=>{fun()});;
    },
  };
};

const Onboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Onboard;



// WEBPACK FOOTER //
// ./src/components/container/Onboard/index.js